module.exports = {

    save:      'Salvare',
    saved:     'Salvato',
    close:     'Chiuso',
    prev:      'Anteriore',
    next:      'Seguente',
    cancel:    'Cancellare',
    back:      'Indietro',
    thanks:    'Grazie!',
    send:      'Inviare',
    show_less: 'Mostrare meno',
    show_more: 'Mostrare di più',
    perfect:   'Ottimo!',
    awesome:   'Fantastico!',
    hello_im:  'salve, sono {0}',
    hello:     'Salve',

    labels : {
        user_name:       'Il tuo nome',
        user_email:      'La tua mail',
        user_phone:      'Il tuo telefono',
        comments:        'Commenti aggiuntivi',
        date:            'Seleziona una data',
        budget_from:     'Da',
        budget_to:       'a',
        amount:          'Totale',
        currency:        'Moneta',
        selection:       'La tua selezione',
        choice_one:      'Seleziona uno',
        choice_city:     'Seleziona una città',
        choice_event:    'Seleziona un evento',
        days_count:      '{count} giorno | {count} giorni',
        days_more:       'più di {count} giorno | più di {count} giorni',
        day_x:           'Giorno {0}',
        total:           'Totale',
        hostesses_count: '{count} hostess | {count} hostess',
        hostesses_more:  'più di {count} hostess | più di {count} hostess',
        guests:          '{count} invitato | {count} invitati',
        services:        '{count} servizio | {count} servizi',
        period:          '{count} período | {count} períodos',
        meals:           '{count} comida | {count} comidas',
    },

    terms_label:       'Ho letto e sono d\'accordo {0}',
    terms_link_label:  'Politica della Privacy',

    errors : {

        area      : 'Misura dello stand?',
        user_name : 'È obbligatorio riempire il campo Nome',
        user_email: 'Serve un indirizzo email valido',
        user_phone: 'È obbligatorio riempire il campo telefono',
        estimate:   'An estimate is requierd',
    },

    rq : {

        stands : {


            labels : {
                city: 'Città in cui ti serve uno Stand',
                event: 'In quale fiera esponi?',
                size: 'Misura dello stand',
                price_rank:       'Range di budget',
                price_rank_help : 'Per fare una corretta selezione dei materiali per il tuo stand dicci per favore in quale range di budget vuoi che lavoriamo.',
            },

            thanks : {
                title : 'Grazie!',
                text  : 'Vi invieremo in 48 ore una selezione delle migliori proposte',
            },

            options_has_design : {

                0 : 'Progetto + Costruzione',
                1 : 'Soltanto costruzione',
                2 : 'Altri servizi'
            },

            page_start_title:     'Richiesta di Stand',
            page_start_subtitle : 'Caratteristiche',
            page_start_options_has_design :{

                0: 'Mi serve la progettazione dello stand, la sua costruzione ed il montaggio e lo smontaggio',
                1: 'Ho già un mio stand e mi serve soltanto il montaggio e smontaggio',
                2: 'Altri',
            },

            page_user_title:      'I tuoi dati di contatto',
            page_user_subtitle:   '',

            page_price_title:     'Range di budget',
            page_price_subtitle : '',

            page_space_title:    'Hai già la conferma dello spazio nella fiera?',
            page_space_subtitle: '',
            page_space_options : {

                0: 'No, ancora sto decidendo se esporre e mi interessa sapere i costi',
                1: 'Si, ho già lo spazio confermato e l\'ubicazione',
            },

            page_type_title    : 'Dicci che tipo di stand stai cercando',
            page_type_subtitle : '',
            page_type_options : {
                design:  'Stand di design',
                modular: 'Stand Modulare',
                mixed :  'Stand Misto',
                display: 'Stand Display',
                none:     'Ancora non lo so'
            },

            page_properties_title:     'Elementi o spazi ti servono nello stand',
            page_properties_subtitle : 'Puoi selezionare tanti come ti servano',
            page_properties_options: {
                counter:            'Desk',
                furniture:          'Mobili',
                multimedia:         'Noleggio multimedia',
                closedMeetingRoom:  'Sala di riunioni chiusa',
                openMeetingRoom:    'Magazzino',
                spaceStorage:       'Sala di riunioni aperta',
                cateringArea:       'Area di catering',
                hangingElements:     'Appendimenti',
            },

            page_staff_title:               'How many employees will be in the stand during the event?',
            page_staff_subtitle:            'Specify the number of employees, what position they have, that are going to be in the stand. This information is helpfull for designing the stand. Example: manager + 3 sales person + hostesses',

            page_price_relevance_title :    'How relevant is the price in your purchase decision?',
            page_price_relevance_subtitle : 'Price and design are two sides of the same coin, with a bigger budget more investment in the design and the materials to build the stand. Tell us how important is each of this aspects',
            page_price_relevance_options  : {

                label1 : 'Relevance:',
                label2 : 'Minimum',
                label3 : 'Low',
                label4 : 'Medium',
                label5 : 'High',
                label6 : 'Maximum',
                label7 : 'Price',
                label8 : 'Design',
            },

            page_price_max_title:    'Budget and currency',
            page_price_max_subtitle: 'You selected the price as the most important aspect. What is the maximun budget?',

            page_upload_alt_title:    'Do you want to attach some design, idea or concept of how your stand should be? This would help us to understand better what do you have in mind.',
            page_upload_alt_subtitle: '',

        },

        hostesses : {


            thanks : {
                title : 'Grazie!',
                text  : 'Inviaci per favore il tuo CV a CV.hostesses@neventum.com e lo faremo arrivare alle nostre agenzie di hostess associate',
            },

            create : {

                1 : {
                    title:       'Richiesta di Hostess',
                    subtitle:    'In quale città e evento ti serve questo servizio?',
                    label1:      'In quale città ti servono hostess?',
                    label2:      'Dicci il nome de l\'evento',
                    placeholder: 'Scrive o seleziona un elemento',
                },
                2 : {
                    title : "Ci puoi confermare quest'informazione, per favore?",
                    label1 : 'Conferma città',
                    label2 : 'Conferma data inizio',
                },

                3 : {
                    'title'         : 'Richiesta di hostess',
                    'subtitle'      : 'I tuoi dati di contatto',
                },
                4 : {
                    'title'         : 'Per darti un migliore servizio dicci, per favore, qual\'è il tuo profilo.',
                    'label1'        : 'Sono un <b>Cliente</b> che sollecita un servizio di hostess',
                    'label2'        : 'Sono un <b>Agenzia</b> a cui serve una hostess per un cliente',
                    'label3'        : 'Sono una <b>hostess</b> cercando lavoro che vuole inviare il suo CV',
                },
                5 : {
                    'title'         : 'Dicci quante hostess ti servono e per quanti giorni.',
                    'label1'        : 'numero di hostess',
                    'label2'        : 'numero di giorni',
                    'label3'        : 'Purtroppo non abbiamo trovado l\'evento nella nostra banca dati, per favore dicci che giorno inizia',
                },
                6 : {
                    'title'         : 'Quante ore ti servono le hostess al giorno',
                    'option1'       : '1 ora',
                    'option2'       : '{0} ore',
                    'option3'       : 'Più di 8 ore',
                },
                7 : {
                    'title'         : 'Quante ore ti servono le hostess al giorno',
                    'option1'       : '1 ora',
                    'option2'       : '{0} ore',
                    'option3'       : 'Più di 8 ore',
                },
                8 : {
                    'title'         : 'Che mansioni dovranno svolgere le hostess?',
                    'body'          : 'Esempio: mi servono ragazze imagine che remangando del desk e che ogni tanto diano delle brochure per la fiera e una hostess bilingue che ci aiuti con il lavoro commerciale, ...',
                },
                9 : {
                    'title'         : 'Lingue richieste',
                    'body'          : 'Seleziona e/o dicci le lingue necessarie',
                    'label1'        : 'Spagnolo',
                    'label2'        : 'Italiano',
                    'label3'        : 'Francese',
                    'label4'        : 'Inglese',
                    'label5'        : 'Tedesco',
                    'label6'        : 'Portoghese',
                    'label7'        : 'Altri',
                },

                'errors' : {
                    'city'              : 'Seleziona una città',
                    'event'             : 'Seleziona un evento',
                    'userName'          : 'Devi introduce il nome di user',
                    'userEmail'         : 'Devi introdurre la mail',
                    'userPhone'         : 'Devi introduce il numero di telefono',
                    'invalidEmail'      : 'Devi introdurre una mail valida',
                    'profile'           : 'Seleziona un profilo',
                    'countHostesses'    : 'Quante hostess ti serviranno?',
                    'countDays'         : 'Quanti giorni starai?',
                    'deadline'          : 'Compila la data di questo evento',
                    'days'              : 'Compila l\'orario di tutti i giorni',
                    'hoursAvg'          : 'Compila l\'orario del giorno',
                    'tasks'             : 'Quali mansioni avranno le hostesss?',
                    'langs'             : 'Che lingue dovranno parlare le hostess?',
                    'otherLang'        : 'Inserisci altre lingue',
                }
            }

        },

        catering : {

            thanks : {
                title         : 'Grazie!'
            },

            guests: 'Ospiti',

            1 : {
                title         : 'Richiesta di Catering',
                subtitle      : 'In quale città o evento ti serve il servizio',
                label1        : 'In quale città ti serve il catering?',
                label2        : 'Come si chiama l\'evento',
                placeholder   : 'Scrive o seleziona un elemento',
            },
            2 : {
                title         : 'Richiesta di catering',
                subtitle      : 'I tuoi dati di contatto',
                placeholder1  : 'Il tuo nome',
                placeholder2  : 'La tua mail',
                placeholder3  : 'Il tuo telefono',
            },
            3 : {
                title:      'Per quanti giorni ti serve il servizio di catering',
                label_days: 'Giorni necessari',
                label_date: 'Purtroppo non abbiamo questo evento ella nostra banca dati, per favore dicci quando inizia?',

            },
            4 : {
                title         : 'Quanti ospiti avrete?',
            },

            5 : {
                title: 'Quanti ospiti attendi per giorno?',
            },
            6 : {
                title         : 'Approssimativamente quanti ospiti avrai al giorno?',
            },
            7 : {
                title         : 'Tipo di servizio che cerchi?',
                title2        : 'In quale orario ti serve il catering ?',
                label1        : 'Buffet durante l\'evento',
                label2        : 'CofeeBreak',
                label3        : 'Piatti principali',
                label4        : 'Tutto il giorno',
                label5        : 'Colazione',
                label6        : 'Prazo',
                label7        : 'Cena',
            },
            8 : {
                title         : 'Che servizi dovrebbero essere inclusi nel preventivo?',
                label1        : 'Camerieri',
                label2        : 'Bevande analcoliche e caffè',
                label3        : 'Bevande alcoliche',
                label4        : 'Cibo',
                label5        : 'Mobili',
                label6        : 'Posate, bicchieri, ...',
            },
            9 : {
                title         : 'Preventivo',
                label1        : 'Preventivo per ospite',
                label2        : 'Preventivo totale de l\'evento',
                text1         : 'Dicci per favore il budget massimo totale che considerate per girarti la migliore opzione di catering in quel range di budget',
                text2         : 'Dicci per favor il budget Massimo per ospite che considerate per presentarti la migliore opzione di catering in fuel range di budget',
            },
            10 : {
                title         : 'Vuoi aggiungere qualcosa?',
                subtitle      : 'Se servono alimenti speciali per intoleranze, tipi di menu particolari, ....'
            },

            labels : {

                service   : {
                    buffet        : 'Buffet',
                    coffeeBreak   : 'CoffeeBreak',
                    mainDishes    : 'Platos principales',
                },
                period    : {
                    allday        : 'Per tutta la durata de l\'evento',
                    breakfast     : 'Colazione',
                    lunch         : 'Pranzo',
                    dinner        : 'Cena',
                },
                budgetType : {
                    byGuest : 'Preventivo per ospite',
                    global  : 'Preventivo totale'
                }
            },

            errors : {
                city:         'Seleziona una città',
                event:        'Seleziona un evento',
                userName:     'Devi compilare il nome di user',
                userEmail:    'Devi compilare la mail',
                userPhone:    'Devi compilare il numero di telefono',
                invalidEmail: 'Devi introdurre una mail valida',
                days:         'Devi selezionare per quanti giorni ti serve',
                deadline:     'Compila la data de l\'evento',
                guests:       'Devi compilare il numero di ospiti',
                daysResume:   'Dicci il numero di ospiti per giorno',
                guestsAvg:    'Devi compilare il numero di ospiti',
                period:       'Seleziona un orario',
                service:      'Seleziona un servizio',
                budgetType:   'Seleziona una opzione per il preventivo',
                budget:       'Budget Massimo',
                budgetFormat: 'Il budget Massimo dev\'essere un numero intero'
            }

        }
    },

    corporation : {

        suppliers : {

            page_navbar_my_brand        : 'Il mio marchio:',
            page_navbar_data            : 'Data',
            page_navbar_presentation    : 'Presentazione',
            page_navbar_geo             : 'Dove lavori',
            page_navbar_stands          : 'I miei stand',
            page_navbar_office          : 'Ufficio',
            page_navbar_scopes          : 'Area lavorativa',

            page_related_is_other       : 'Creare nuova azienda',
            page_related_is_this        : 'Questa è la mia azienda',
            page_related_created_by     : 'Profilo <b>creato per {0}</b> il {1}',
            page_related_not_suggested  : 'La mia azienda non è quella suggerita, vorrei continuare con il processo:',

            page_resolution_label_1     : 'Non fate <b>niente</b>, lo sistemeremo internamente',
            page_resolution_label_2     : '{0} porterà ancora il marchio ma <b> vorrei i permessi per attualizzare il contenuto, ricevere leads</b>, ...',
            page_resolution_label_3     : '{0} ormai non è più il responsabile di gestire il contenuto, <b>da adesso sono io responsabile</b> di questo contenuto',

            labels  : {
                name                    : 'Nome della tua azienda',
                city                    : 'Città',
                sector                  : 'Settore di attività',
                address                 : 'Sito Web',
                web                     : 'Indirizzo',
            },

            alerts : {

                group_suppliers_text_1  : '<b>È questa la tua azienda?</b>',
                group_suppliers_text_2  : 'Qualcuno della tua azienda ha un profilo su neventum - lo abbiamo saputo per la mail corporativa',
                group_suppliers_text_3  : 'Abbiamo pensato che sarebbe buono avvertirti per se fosse la stessa azienda e possiamo risparmiarti il lavoro ;)',
                group_suppliers_text_4  : 'Se volevi creare proprio quella avvertici e sollecita, se vuoi, permessi di edizione. Se era un’altra azienda indicacelo e andiamo avanti con il processo.',

                other_suppliers_text_1  : '<b>È questa la tua azienda?</b>',
                other_suppliers_text_2  : 'In base a l’informazione che hai introdotto del tuo marchio abbiamo trovato alcuni marchi che assomigliano su neventum.',
                other_suppliers_text_3  : 'Per evitare di duplicare un marchio che abbia potuto creare un tuo collega te le mostriamo a continuazione.',
                other_suppliers_text_4  : 'Se volevi creare proprio quella avvertici e sollecita, se vuoi, permessi di edizione. Se era un’altra azienda indicacelo e andiamo avanti con il processo.',

                resolution_text_1        : '<b>Ottimo!</b>',
                resolution_text_2        : 'Soltanto ci serve sapere chi gestirà il marchio da adesso in poi: tu, il tuo collega, tutti e due…',
                resolution_text_3        : 'Seleziona un’opzione a continuazione.',

            },

            page_thank_send_email       : 'Abbiamo inviato una mail a {0} perche ti aggiunga i permessi necessari',
            page_thank_we_wait          : 'Rimaniamo in attesa delle vostre notizie!',
            page_thank_will_help        : 'ti aiuterò con il cambio di proprietario di {0}, ti contattarò presto per iniziare il processo.',
        }
    },

    event : {

        page_related_from_to : 'dalla {0} alla {1}',
        page_related_is_this : 'Sollecitare Evento',
        page_related_not_suggested : 'Il mio evento non coincide con i suggerimenti, voglio continuare il processo:',
        page_related_is_other : 'Non è nessuno di questi',

        page_thank_label_1 : 'Ciao {0},',
        page_thank_label_2 : 'Il nostro staff di contenuti sta controllando la tua richiesta per aggiungere questo evento al tuo profilo.',
        page_thank_label_3 : 'Entro 24 ore ( esclusi i giorni festivi ) sarà risolto ;)',
        page_thank_label_4 : 'Ti terremo aggiornato/a e ti invitiamo ad aggiungere altri eventi che organizzi',
        page_thank_label_5 : 'Un saluto',
        page_thank_label_6 : 'neventum Editorial Staff',

        labels : {
            'sector' : "Settore dell'evento",
            'periodicity' : "Periodicità dell'evento",
            'scope' : "Portata dell'evento",
            'name' : "Nome dell'evento"
        },

        periodicity : {
            mensual : 'Mensile',
            trimestral : 'Trimestrale',
            semestral : 'Semestrale',
            anual : 'Annuale',
            bienal : 'Biennale',
            trienal : 'Triennale',
            cuatrienal : 'Quadriennale',
        },

        scopes : {
            local : 'Locale',
            national : 'Nazionale',
            international : 'Internazionale',
        },

        alerts : {

            related_events_text_1 : '<b>È questo il tuo evento?</b>',
            related_events_text_2 : "Sulla base dell'informazione che ci hai fornito sul tuo evento abbiamo trovato alcuni eventi simili su neventum.",
            related_events_text_3 : "Per evitare di pubblicare di nuovo l'evento che già abbiamo sul nostro calendario te li mostriamo a continuzione.",
            related_events_text_4 : 'Se era uno di questi eventi avvertici e sollecita, se vuoi, permessi per poterlo editare',

        },
    },

    reviews : {

        thanks : 'Grazie per condividere la tua opinione',

        labels : {

            rate      : 'La tua qualifica generale',
            opinion   : 'La tua opinione',

            city                : 'In quale città si è costruito lo stand',
            city_stands         : 'In quale città si è costruito lo stand',
            city_catering       : "Dov'era l evento?",
            city_hostesses      : "In quale città ti servivano le hostess?",

            worked_at           : 'Quando ti ha costruito lo stand',
            worked_at_stands    : 'Quando ti ha costruito lo stand',
            worked_at_catering  : "Quando e'stato l evento?",
            worked_at_hostesses : "Quando e'stato l evento?",

            name      : 'Il tuo nome',
            email     : 'La tua mail',
            anonymous : 'Voglio che la mia opinione sia anonima, il mio nome non comparirà ne verrà comunicato al fornitore di cui sto opinando',
            accept    : 'Certifico che questa opinione si basa nella mia propria esperienza ed è la mia opinione vera su questo fornitore e che non ho nessun rapporto personale né commerciale con loro ne mi hanno offerto nessun tipo di compenso perche scrivesse questa opinione. Comprendo che neventum ha una politica di toleranza zero con le opinioni false.',
            submit    : 'Invia la tua opinione',
        },

        help : {
            name  : 'Il tuo nome non sarà pubblico se ce lo chiedi',
            email : 'Questa informazione MAI sarà pubblica',
        },
    },

    rate : {
        label          : 'Haz clic para puntuar',
        label_bad       : 'Bad',
        label_poor      : 'Poor',
        label_fair      : 'Fair',
        label_good      : 'Good',
        label_excellent : 'Excellent',
    },

    cookie : {
        text            : 'Le cookies raccolgono informazione nel tuo navigatore web per offrirti una migliore esperienza online. In neventum usiamo cookies, se vai avanti consideriamo che accetti il suo uso.',
        label_accept    : 'Accettare',
        label_info      : 'Più informazione',
    },

    session : {
        login :     'Effettua il login',
        register :  'Registrati',
    },
};



// WEBPACK FOOTER //
// ./resources/js/i18n/it.js